import React from 'react';
import BannerConfigs from '@MerchantConfigurator/components/messaging/ControlPanel/BannerConfigs';
import MessageConfigs from '@MerchantConfigurator/components/messaging/ControlPanel/MessageConfigs';
import { BannerLayoutPlacements } from '@MerchantConfigurator/constants';
import PropTypes from 'prop-types';

const PlacementControls = ({ placement, placementConfig, updateConfig, updateCounters }) => {
  const PlacementConfigs = BannerLayoutPlacements.has(placement) ? (
    <BannerConfigs
      placement={placement}
      placementConfig={placementConfig}
      updateConfig={updateConfig}
      updateCounters={updateCounters}
    />
  ) : (
    <MessageConfigs
      placement={placement}
      placementConfig={placementConfig}
      updateConfig={updateConfig}
      updateCounters={updateCounters}
    />
  );
  return PlacementConfigs;
};

export default PlacementControls;

PlacementControls.propTypes = {
  label: PropTypes.string,
  placement: PropTypes.string,
  placementConfig: PropTypes.object,
  placementConfigIndex: PropTypes.number,
  placementIndex: PropTypes.number,
  shouldExpand: PropTypes.bool,
  showDropDown: PropTypes.bool,
  showPartnerExperience: PropTypes.bool,
  updateActiveIndex: PropTypes.func,
  updateConfig: PropTypes.func,
  updateCounters: PropTypes.func
};
